import settings from '../appSettings'
let sessionToken = null
class AppHelper {

    static getPingUrl = () => {
        return settings.PING_URL
    }
    static getApiUrl = (url) => {
        return `${settings.API_URL}${url}`
    }

    static getSessionTokenHeaders = () => {
        return {
            'Authorization': `Bearer ${AppHelper.getParameterByName('sessionToken')}`
        };
    }

    static getSessionToken = () => {
        return sessionToken;
    }

    static getParameterByName = (name, url) => {
        if (!url) url = window.location.href;
        /* eslint-disable-next-line */
        name = name.replace(/[\[\]]/g, (match) => `\\${match}`);
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    static setSessionToken = (token) => {
        sessionToken = token
    }

    static formatPhoneNumber = (number) => {
        const value = number.split('-').join('')
        return `${value.substring(0, 1)}-${value.substring(1, 4)}-${value.substring(4, 7)}-${value.substring(7, 11)}`
    }

    static getMiddlewareApiUrl = (url) => {
        return (`${settings.MIDDLEWARE_BASE_URL}${url}`);
    }
}
export default AppHelper;
